import { Input, Flex, Box, FormField } from '@zillow/constellation';
import React from 'react';
import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { prettyACHDisbursementCategory } from 'types/order/escrow/eEscrowAchPushDisbursementCategories';
import { IAchPushDisbursementData } from 'types/order/escrow/IAchPushDisbursementData';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';

interface IVoidACHDetailsProps {
  achDisbursement: IACHDisbursementFormData | IAchPushDisbursementData;
}

export const VoidACHDetails: React.FC<IVoidACHDetailsProps> = ({ achDisbursement }) => {
  return (
    <Flex display={'flex'} flexDirection={'column'} gap={1}>
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <Box sx={{ flexGrow: '1' }}>
          <FormField
            label="Amount"
            control={<Input value={currencyDisplay(achDisbursement.amountCents, true)} disabled />}
          />
        </Box>
        {achDisbursement.category && (
          <Box sx={{ flexGrow: '1' }}>
            <FormField
              label="Category"
              control={
                <Input
                  value={prettyACHDisbursementCategory[achDisbursement.category] ?? achDisbursement.category}
                  disabled
                />
              }
            />
          </Box>
        )}
      </Flex>
      <FormField label={'Name'} control={<Input value={achDisbursement.account?.name ?? ''} disabled />} />
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <Box sx={{ flexGrow: '1' }}>
          <FormField
            label={'Routing ABA'}
            control={<Input value={achDisbursement.account?.routingNumber ?? ''} disabled />}
          />
        </Box>
        <Box sx={{ flexGrow: '1' }}>
          <FormField
            label={'Account Number'}
            control={<Input value={achDisbursement.account?.accountNumber ?? ''} disabled />}
          />
        </Box>
      </Flex>
      <FormField label="Memo" control={<Input value={achDisbursement.wellsFargoTransactionNumber ?? ''} disabled />} />
    </Flex>
  );
};
